import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { createSharingLinkFromFileProvider } from 'owa-fileprovider-link-services';
import type { FilePickerData } from '../schema';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default async function getUrlFromFilePickerData(file: FilePickerData): Promise<string> {
    if (!file) {
        return '';
    }

    // We first try to get a sharing link from the provider
    try {
        const sharingLink = await createSharingLinkFromFileProvider(
            file.fileProvider!,
            file.fileId,
            file.location,
            file.filePickerLinkData.isFolder,
            file.providerEndpointUrl
        );
        return sharingLink.link.webUrl;
    } catch (e) {
        // For ODB links we can fall back to the location (canonical url)
        if (file.fileProvider === AttachmentDataProviderType.OneDrivePro) {
            return file.location;
        }

        logSpacesDatapoint('OUTLOOKSPACES_NO_LINK_FOR_FILE', {
            fileProvider: file.fileProvider,
            error: e.message,
            callstack: e.stack,
        });
        throw new Error('no link for for item');
    }
}
